/**
 * Created by tschenkel on 6/30/2015.
 */

/**
 * Error class used by the module to dispatch error messages when needed.
 *
 * @see com.goodgamestudios.core.localization.errors.LocalizationModuleErrorConstants
 */
export class LocalizationModuleError extends Error {
    private _id: string = "";

    /**
     * Creates a new error object.
     * @param message Error message.
     * @param id Error code.
     */
    constructor(message: string = "", id: string = "") {
        super(message);

        this._id = id;
    }

    public get id(): string {
        return this._id;
    }
}
